<!-- test-report.component.html -->
<div class="container-fluid p-4 bg-dark text-white " id="reportContainer">
  <div class="row flex-column mb-4 kpi-row header">
    <!-- Header -->
    <div class="col-md-8 header-title">
      <h1 class="display-4 mb-2">Test Execution Reports</h1>
      <p class="text-muted">Comprehensive testing analytics and insights</p>
    </div>
    <!-- implementation for this is still pennding that why commented -->
    <!-- <div class="col-md-4 text-right header-actions">
      <button class="btn btn-primary mr-2" (click)="exportPDF()">
        <i class="fas fa-download"></i> Export PDF
      </button>
      <button class="btn btn-success" (click)="exportExcel()">
        <i class="fas fa-file-excel"></i> Export Excel
      </button>
    </div> -->
    <div class="topSearch header-actions">
      <select name="account_number" id="account_number" [(ngModel)]="selectedAccountId" (change)="onAccountChange()">
        <option value="" disabled>Select Account</option>
        <option *ngFor="let account of adminAccounts" [value]="account.accountId.toString()">
          {{ account.accountNo }}
        </option>
      </select>
      <select name="project_number" id="project_number" [(ngModel)]="selectedProjectId" (change)="onProjectChange()" [disabled]="!selectedAccountId || accountProjects.length === 0">
        <option value="">All Projects</option>
        <option *ngFor="let project of accountProjects" [value]="project.projectId">
          {{ project.displayName }}
        </option>
      </select>
    </div>
  </div>

  <!-- Tab Navigation -->
  <div class="row mb-4 kpi-row">
    <div class="col-12">
      <ul class="nav nav-tabs bg-secondary rounded">
        <li class="nav-item flex-fill">
          <a class="nav-link text-center" [class.active]="activeTab === 'executive'" (click)="setActiveTab('executive')"
            style="cursor: pointer;">
            <i class="fas fa-chart-line"></i> Executive Dashboard
          </a>
        </li>
        <li class="nav-item flex-fill">
          <a class="nav-link text-center" [class.active]="activeTab === 'analytics'" (click)="setActiveTab('analytics')"
            style="cursor: pointer;">
            <i class="fas fa-chart-bar"></i> Detailed Analytics
          </a>
        </li>
        <li class="nav-item flex-fill">
          <a class="nav-link text-center" [class.active]="activeTab === 'team'" (click)="setActiveTab('team')"
            style="cursor: pointer;">
            <i class="fas fa-users"></i> Team Performance
          </a>
        </li>
        <li class="nav-item flex-fill">
          <a class="nav-link text-center" [class.active]="activeTab === 'quality'" (click)="setActiveTab('quality')"
            style="cursor: pointer;">
            <i class="fas fa-award"></i> Quality Metrics
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Executive Dashboard Tab -->
  <div *ngIf="activeTab === 'executive'" class="container-scroll">
    <!-- KPI Cards -->
    <div class="row mb-4 kpi-row">
      <div class="col-md-2">
        <div class="card bg-primary text-white">
          <div class="card-body text-center">
            <i class="fas fa-file-alt fa-2x mb-2"></i>
            <h3 class="mb-0">{{ executiveSummary.totalTests }}</h3>
            <small>Total Test Cases</small>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card bg-success text-white">
          <div class="card-body text-center">
            <i class="fas fa-check-circle fa-2x mb-2"></i>
            <h3 class="mb-0">{{ executiveSummary.passed }}</h3>
            <small>Passed Tests</small>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card bg-danger text-white">
          <div class="card-body text-center">
            <i class="fas fa-times-circle fa-2x mb-2"></i>
            <h3 class="mb-0">{{ executiveSummary.failed }}</h3>
            <small>Failed Tests</small>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-info text-white">
          <div class="card-body text-center">
            <i class="fas fa-percentage fa-2x mb-2"></i>
            <h3 class="mb-0">{{ executiveSummary.passRate }}%</h3>
            <small>Pass Rate</small>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-warning text-white">
          <div class="card-body text-center">
            <i class="fas fa-robot fa-2x mb-2"></i>
            <h3 class="mb-0">{{ executiveSummary.automationRate }}%</h3>
            <small>Automation Rate</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Row -->
    <div class="row mb-4 kpi-row">
      <div class="col-md-6">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0"><i class="fas fa-chart-area"></i> Testcase Execution Trend (Last 4 Weeks)</h5>
          </div>
          <div class="card-body" style="height: 350px;">
            <canvas baseChart [datasets]="trendChartData.datasets" [labels]="trendChartData.labels"
              [options]="trendChartOptions" [chartType]="'line'">
            </canvas>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0"><i class="fas fa-chart-bar"></i> Pass Rate by Category</h5>
          </div>
          <div class="card-body category-chart-container">
            <div class="category-chart-wrapper" [style.width.px]="getCategoryChartWidth()">
              <canvas baseChart [datasets]="categoryChartData.datasets" [labels]="categoryChartData.labels"
                [options]="categoryChartOptions" [chartType]="'bar'">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Top Failing Tests -->
    <div class="row mb-4 kpi-row">
      <div class="col-12">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0"><i class="fas fa-exclamation-triangle text-warning"></i> Top Failing Test Cases</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-dark table-striped table-hover">
                <thead>
                  <tr>
                    <th>Test ID</th>
                    <th>Test Name</th>
                    <th>Category</th>
                    <th class="text-center">Failure Count</th>
                    <th>Last Failed</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="topFailingTests.length === 0">
                    <td colspan="6" class="text-center text-muted">
                      No failed test executions found
                    </td>
                  </tr>
                  <tr *ngFor="let test of topFailingTests">
                    <td><code>{{ test.testCaseId }}</code></td>
                    <td>{{ test.testCaseName }}</td>
                    <td>
                      <div class="category-badges">
                        <span *ngFor="let cat of test.category" class="badge badge-primary">{{ cat }}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span class="badge badge-danger font-weight-bold">{{ test.failureCount }}</span>
                    </td>
                    <td class="text-muted">{{ test.lastFailed }}</td>
                    <td class="text-center">
                      <a href={{test.reportLink}}> <button class="btn btn-sm btn-warning">Investigate</button></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Detailed Analytics Tab -->
  <div *ngIf="activeTab === 'analytics'" class="container-scroll">
    <div class="row mb-4 kpi-row">
      <!-- Priority Distribution -->
      <div class="col-md-4">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0">Priority Distribution</h5>
          </div>
          <div class="card-body" style="height: 350px;">
            <canvas baseChart [data]="pieChartData.datasets[0].data" [labels]="pieChartData.labels"
              [options]="pieChartOptions" [colors]="[{backgroundColor: pieChartData.datasets[0].backgroundColor}]"
              [chartType]="'pie'">
            </canvas>
          </div>
        </div>
      </div>

      <!-- Environment Results
      <div class="col-md-4 kpi-row">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0">Environment-wise Results</h5>
          </div>
          <div class="card-body" style="height: 350px;">
            <canvas baseChart [datasets]="environmentChartData.datasets" [labels]="environmentChartData.labels"
              [options]="environmentChartOptions" [chartType]="'bar'">
            </canvas>
          </div>
        </div>
      </div> -->

      <!-- Test Coverage -->
      <div class="col-md-4 kpi-row">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0">Testcase Coverage by Category</h5>
          </div>
          <div class="card-body testData">
            <div *ngFor="let module of testCoverage" class="mb-3">
              <div class="detailsData mb-1">
                <span class="font-weight-bold">{{ module.module }}</span>
                <span class="text-muted">{{ module.coverage }}%</span>
              </div>
             <div class="progress" style="height: 20px;">
                <div class="progress-bar" [ngClass]="{
                          'bg-info': module.coverage == 0,
                          'bg-success': module.coverage >= 80,
                          'bg-warning': module.coverage >= 60 && module.coverage < 80,
                          'bg-danger': module.coverage < 60}" 
                          [style.width.%]="module.coverage" role="progressbar" [attr.aria-valuenow]="module.coverage"
                  aria-valuemin="0" aria-valuemax="100">
                  {{ module.coverage }}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Automation Progress & Defect Analysis -->
    <div class="row mb-4 kpi-row">
      <div class="col-md-6">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0"><i class="fas fa-robot"></i> Automation Progress</h5>
          </div>
          <div class="card-body" style="height: 350px;"  *ngIf="hasPassedTests">
            <canvas baseChart [datasets]="automationChartData.datasets" [labels]="automationChartData.labels"
              [options]="automationChartOptions" [chartType]="'line'">
            </canvas>
          </div>

          <div class="card-body text-center py-5" *ngIf="!hasPassedTests">
            <i class="fas fa-chart-line fa-3x text-muted mb-3"></i>
            <p class="text-muted">No data available. Complete test executions to view automation progress.</p>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0"><i class="fas fa-bug"></i> Defect Status by Severity</h5>
          </div>
          <div class="card-body" style="height: 350px;">
            <canvas baseChart [datasets]="defectChartData.datasets" [labels]="defectChartData.labels"
              [options]="defectChartOptions" [chartType]="'bar'">
            </canvas>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Team Performance Tab -->
  <div *ngIf="activeTab === 'team'" class="container-scroll">

     <div class="topSearch topSearch-left">
      <select name="report_period" id="report_period_team" [(ngModel)]="teamPeriod" (change)="onTeamPeriodChange()">
        <option value="ALL">All</option>
        <option value="TODAY">Today</option>
        <option value="WEEKLY">Weekly</option>
        <option value="MONTHLY">Monthly</option>
      </select>
    </div>
    <div class="row mb-4 kpi-row">
      <div class="col-12">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0"><i class="fas fa-users"></i> Tester Performance Metrics</h5>
            <div class="header-actions">
            </div>
          </div>
          <div class="card-body">
            <ze-loader *ngIf="isUserListLoading"></ze-loader>
            <div class="table-responsive" *ngIf="!isUserListLoading">
              <table class="table table-dark table-striped">
                <thead>
                  <tr>
                    <th>Tester Name</th>
                    <th class="text-center">Total Executions</th>
                    <th class="text-center">Executions Failed</th>
                    <th class="text-center">Executions Pass Rate</th>
                    <th class="text-center">Efficiency Score</th>
                    <th>Performance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let member of teamPerformance">
                    <td class="font-weight-bold">{{ member.tester }}</td>
                    <td class="text-center">{{ member.executed }}</td>
                    <td class="text-center">{{ member.failed }}</td>
                    <td class="text-center">
                      <span class="badge"
                        [class.badge-success]="calculatePassRate(member.passed, member.executed) >= 85"
                        [class.badge-warning]="calculatePassRate(member.passed, member.executed) < 85">
                        {{ calculatePassRate(member.passed, member.executed) }}%
                      </span>
                    </td>
                    <td class="text-center">{{ member.efficiency }}%</td>
                    <td>
                      <div class="progress" style="height: 20px;">
                        <div class="progress-bar bg-info" [style.width.%]="member.efficiency">
                          {{ member.efficiency }}%
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="userSearchErrorMessage" style="color:red; padding: 0.5vmax;">
                {{ userSearchErrorMessage }}
              </p>
              <div class="footer">
                <button class="btn-primary" [disabled]="userStartIndex === 0"
                  (click)="getAdminUserList(userStartIndex - PAGE_SIZE)">Previous</button>
                <button class="btn-primary" [disabled]="visibleUserList.length < PAGE_SIZE || !userHasNext"
                  (click)="getAdminUserList(userStartIndex + PAGE_SIZE)">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Quality Metrics Tab -->
  <div *ngIf="activeTab === 'quality'" class="container-scroll">

    <div class="topSearch topSearch-left">
      <select name="report_period" id="report_period_quality" [(ngModel)]="qualityPeriod" (change)="onQualityPeriodChange()">
        <option value="ALL">All</option>
        <option value="TODAY">Today</option>
        <option value="WEEKLY">Weekly</option>
        <option value="MONTHLY">Monthly</option>
      </select>
    </div>
    <!-- Quality KPIs -->

     <!-- Footer Summary -->
    <div class="row mt-4 mb-4 kpi-row">
      <div class="col-12">
        <div class="card bg-secondary">
          <div class="card-body">
            <div class="row text-center bottom-summary">
              <div class="col">
                <small class="text-muted d-block mb-1">Report Generated</small>
                <strong>
                   {{ currentDate | date:'MMM d, y' }}
                </strong>
              </div>
              <div class="col">
                <small class="text-muted d-block mb-1">Total Execution Count</small>
                <strong>
                  {{ adminDetailsReports.numberOfExecutions === '' || adminDetailsReports.numberOfExecutions == null
                  ? 0
                  : adminDetailsReports.numberOfExecutions }}
                </strong>
              </div>
              <div class="col">
                <small class="text-muted d-block mb-1">TestCase Execution Avg Duration</small>
                <strong>{{ executionHoursData.testExecutionHours }}</strong>
              </div>
               <div class="col">
                <small class="text-muted d-block mb-1">Total Execution Duration</small>
                <strong>{{ executionHoursData.overallExecutionHours }}</strong>
              </div>
              <!-- <div class="col">
                <small class="text-muted d-block mb-1">Critical Issues</small>
                <strong [ngClass]="criticalIssuesCount > 0 ? 'text-danger' : ''">
                  {{ criticalIssuesCount != null ? criticalIssuesCount : 0 }}
                </strong>
              </div> -->
              <!-- <div class="col">
                <small class="text-muted d-block mb-1">Test Environments</small>
                <strong>4</strong>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div id="admin_highlighted_report">
      <ze-loader *ngIf="isDashboardLoading"></ze-loader>

      <div class="kpi-grid" *ngIf="!isDashboardLoading">
        <div class="kpi-card">
          <div class="card bg-info text-white">
            <div class="card-body text-center">
              <i class="fas fa-award fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.totalBugSaved}}</h3>
              <small>Total Bugs Saved</small>
            </div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="card bg-primary text-white">
            <div class="card-body text-center">
              <i class="fas fa-bullseye fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.noOfOpenCodeReviews}}</h3>
              <small>Open Code Review</small>
            </div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="card bg-danger text-white">
            <div class="card-body text-center">
              <i class="fas fa-bug fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.totalReworkSaved}}</h3>
              <small>Total Rework Saved</small>
            </div>
          </div>
        </div>
        <!-- <div class="kpi-card">
          <div class="card bg-success text-white">
            <div class="card-body text-center">
              <i class="fas fa-clock fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.numberOfExecutions}}</h3>
              <small>Executions</small>
            </div>
          </div>
        </div> -->

        <!-- Row 2 -->
        <div class="kpi-card">
          <div class="card bg-warning  text-white">
            <div class="card-body text-center">
              <i class="fas fa-clock fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.savedCodeReviewWork}}</h3>
              <small>Saved Code Review Work</small>
            </div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="card bg-purple text-white">
            <div class="card-body text-center">
              <i class="fas fa-clock fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.totalSuites}}</h3>
              <small>Total Suites</small>
            </div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="card bg-teal text-white">
            <div class="card-body text-center">
              <i class="fas fa-clock fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.totalUsers}}</h3>
              <small>Total Users</small>
            </div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="card bg-orange text-white">
            <div class="card-body text-center">
              <i class="fas fa-clock fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.totalProjects}}</h3>
              <small>Total Projects</small>
            </div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="card bg-indigo text-white">
            <div class="card-body text-center">
              <i class="fas fa-clock fa-2x mb-2"></i>
              <h3 class="mb-0">{{adminDetailsReports.businessReviewSaved}}</h3>
              <small>Business Review Saved</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4 kpi-row">
      <div class="col-12">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0"><i class="fas fa-exclamation-triangle text-warning"></i> Project Matrix</h5>
          </div>
          <div class="card-body">

            <ze-loader *ngIf="isProjectListLoading"></ze-loader>

            <div class="table-responsive" *ngIf="!isProjectListLoading">
              <table class="table table-dark table-striped table-hover">
                <thead>
                  <tr>
                    <!-- <th>Test ID</th> -->
                    <th class="text-center">Project Name</th>
                    <th class="text-center">Suite</th>
                    <th class="text-center">Feature</th>
                    <th class="text-center">Scenario</th>
                    <th class="text-center">Step</th>
                    <th class="text-center">Execution</th>
                    <th class="text-center">Open CodeReview</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="visibleProjectList.length === 0">
                    <td colspan="6" class="text-center text-muted">
                      No Projects available
                    </td>
                  </tr>
                  <tr *ngFor="let item of visibleProjectList">
                    <td id="qulityTable" class="text-center"><code>{{ item.projectName}}</code></td>
                    <td class="text-center">{{item.noOfSuites}}</td>
                    <td class="text-center">{{item.noOfFeatures}}</td>
                    <td class="text-center">{{item.noOfScenarios}}</td>
                    <td class="text-center">{{item.noOfSteps}}</td>
                    <td class="text-center">{{item.noOfExecutions}}</td>
                    <td class="text-center">{{item.noOfOpenedCodeReview}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- Add error message here -->
              <p *ngIf="projectSearchErrorMessage" style="color:red; padding: 0.5vmax;">
                {{ projectSearchErrorMessage }}
              </p>
              <div class="footer">
                <button class="btn-primary" [disabled]="projectStartIndex === 0"
                  (click)="getAdminProjectList(projectStartIndex - PAGE_SIZE)">Previous</button>
                <button class="btn-primary" [disabled]="visibleProjectList.length < PAGE_SIZE || !projectHasNext"
                  (click)="getAdminProjectList(projectStartIndex + PAGE_SIZE)">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Separator between Project Matrix and Defect Density -->
    <hr class="section-separator" />

    <!-- Defect Density -->
    <div class="row mb-4 kpi-row">
      <div class="col-md-6">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0">Defect Density by Category</h5>
          </div>
          <div class="card-body testData">
            <div *ngFor="let cat of categoryData" class="mb-3">
              <div class="detailsData">
                <span class="font-weight-bold">{{ cat.category }}</span>
                <span class="text-muted">{{ getDefectDensity(cat.failed, cat.total) }}% defect rate</span>
              </div>
              <div class="progress" style="height: 20px;">
                <div class="progress-bar" [ngClass]="getDefectClass(getDefectDensity(cat.failed, cat.total))"
                  [style.width.%]="getDefectDensity(cat.failed, cat.total) || 0"
                  role="progressbar" [attr.aria-valuenow]="getDefectDensity(cat.failed, cat.total)" aria-valuemin="0"
                  aria-valuemax="100">
                  {{ getDefectDensity(cat.failed, cat.total) }}% defect rate
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card bg-secondary">
          <div class="card-header">
            <h5 class="mb-0">Quality Trends</h5>
          </div>
          <div class="card-body">
            <div class="alert alert-success mb-3">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <i class="fas fa-arrow-up mr-2"></i>
                  <strong>Pass Rate {{ hasPassedTests ? 'Improved' : 'Status' }}</strong>
                  <p class="mb-0 text-muted small">
                    {{ hasPassedTests ? '+5.2% from last sprint' : 'No tests passed yet' }}
                  </p>
                </div>
                <h3 class="mb-0">↑</h3>
                </div>
            </div>

            <div class="alert alert-warning mb-3">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <i class="fas fa-exclamation-circle mr-2"></i>
                  <strong>Critical Defects</strong>
                  <p class="mb-0 text-muted small">{{criticalIssuesCount}} open issues</p>
                </div>
                <h3 class="mb-0">!</h3>
              </div>
            </div>

            <div class="alert alert-info mb-0">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <i class="fas fa-robot mr-2"></i>
                  <strong>Automation Coverage</strong>
                  <p class="mb-0 text-muted small">{{ executiveSummary.automationRate }}% automated</p>
                </div>
                <h3 class="mb-0">✓</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>